import React from 'react';
import Icon from '../../../components/AppIcon';

const SystemHealthCard = ({ title, value, status, trend, icon, description }) => {
  const getStatusColor = () => {
    switch (status) {
      case 'healthy': return 'text-success';
      case 'warning': return 'text-warning';
      case 'critical': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getStatusBg = () => {
    switch (status) {
      case 'healthy': return 'bg-success/10';
      case 'warning': return 'bg-warning/10';
      case 'critical': return 'bg-error/10';
      default: return 'bg-muted';
    }
  };

  const getTrendIcon = () => {
    if (trend > 0) return 'TrendingUp';
    if (trend < 0) return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend > 0) return 'text-success';
    if (trend < 0) return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-elevation-2 border border-border transition-smooth hover:shadow-elevation-3">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${getStatusBg()} flex items-center justify-center`}>
          <Icon name={icon} size={20} className={getStatusColor()} />
        </div>
        <div className={`px-2 py-1 md:px-3 md:py-1.5 rounded-full text-xs md:text-sm font-medium ${getStatusBg()} ${getStatusColor()}`}>
          {status?.charAt(0)?.toUpperCase() + status?.slice(1)}
        </div>
      </div>
      <h3 className="text-xs md:text-sm text-muted-foreground mb-1 md:mb-2">{title}</h3>
      <div className="flex items-end justify-between">
        <div>
          <p className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-1">{value}</p>
          {description && (
            <p className="text-xs md:text-sm text-muted-foreground">{description}</p>
          )}
        </div>
        {trend !== undefined && (
          <div className={`flex items-center gap-1 ${getTrendColor()}`}>
            <Icon name={getTrendIcon()} size={16} />
            <span className="text-xs md:text-sm font-medium">{Math.abs(trend)}%</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SystemHealthCard;